import { ThemeProvider } from 'styled-components';
import { CommonThemeProvider, ThemeProsolve } from '@prosolve/common-components-ui';
import { theme as prosolveTheme } from './themes/prosolveTheme';

// THEME SELECTION DISABLED — the portal must only ever use the light theme.
// To re-enable theme selection ('Light'/'Dark', browser dark preference, and ?theme= query string changes),
// restore the commented code below and remove isHideTheme={true} from HubTopNav in Main/Main.js.
// import { useEffect, useState } from 'react';
// import { useSearchParams } from 'react-router-dom';
// import { CommonThemeProvider, ThemeProsolve, ThemeProsolveDark, Themes, useCommonThemeData } from '@prosolve/common-components-ui';
// import useMediaQuery from './hooks/useMediaQuery';
// import { theme as prosolveDarkTheme } from './themes/prosolveDarkTheme';
// import { theme as questTheme } from './themes/questTheme';

const appThemes = [
  { props: ThemeProsolve }
]
// const appThemes = [
//   { name: 'Light', props: ThemeProsolve, darkProps: ThemeProsolveDark },
//   { name: 'Dark', props: ThemeProsolveDark, darkProps: ThemeProsolveDark }
// ]

export default ({ children }) => {
  // THEME SELECTION DISABLED — restore the commented code below to re-enable
  // const [themes, setThemes] = useState()
  //
  // const [searchParams] = useSearchParams();
  //
  // useEffect(() => {
  //   const theme = searchParams.get('theme');
  //   const themes = theme ? Themes.filter(t => t.name === theme) : appThemes
  //   setThemes(themes)
  // }, [searchParams])

  return (
    <CommonThemeProvider themes={appThemes}>
      <InternalThemeWrapper>
          {children}
      </InternalThemeWrapper>
    </CommonThemeProvider>
  )
}

const InternalThemeWrapper = ({ children }) => {
  // THEME SELECTION DISABLED — restore the commented code below (and swap prosolveTheme for activeTheme) to re-enable
  // const [activeTheme, setActiveTheme] = useState(ThemeProsolve)
  //
  // const [searchParams] = useSearchParams();
  // const { preferredTheme } = useCommonThemeData()
  // const prefersDarkMediaQuery = useMediaQuery('(prefers-color-scheme: dark)')
  //
  // useEffect(() => {
  //   const theme = searchParams.get('theme');
  //   const isPrefersDark = preferredTheme ? preferredTheme.includes('Dark') : prefersDarkMediaQuery
  //   const activeTheme = (theme === 'Prosolve' ? prosolveTheme : theme === 'Quest' ? questTheme : theme === 'Prosolve Dark' ? prosolveDarkTheme : isPrefersDark ? prosolveDarkTheme : prosolveTheme);
  //
  //   setActiveTheme(activeTheme)
  // }, [searchParams, preferredTheme, prefersDarkMediaQuery])

  return (
    <ThemeProvider theme={prosolveTheme}>
      {children}
    </ThemeProvider>
  )
}
